module.exports = __webpack_public_path__ + "static/media/kredyt_37.657772f4.png";